export default __webpack_public_path__ + "static/media/MaskGroup-2.d8b1eee3.svg";